import { createFileRoute } from "@tanstack/react-router";
import CategoryList from "@/components/category/category-list";
import { CategoryModals } from "@/components/category/category-modals";
import { Button } from "@/components/ui/button";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/products/categories")({
  component: CategoriesPage,
});

function CategoriesPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <div className="max-w-6xl mx-auto">
        <CategoryModals />
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-semibold"> {t("Categories")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_category");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add a category")}
          </Button>
        </header>
        <CategoryList />
      </div>
    </>
  );
}
